<template>
  <div class="checkup-field">
    <div
      class="checkup-field-checkbox"
      @click="toggleField">
      <div class="checkup-field-dot-circle" v-if="field.selected"></div>
      <div class="checkup-field-circle" v-else></div>
    </div>

    {{field.label}}

    <div class="checkup-field-input">
      <input
        v-if="field.type === 'input'"
        type="text"
        v-model="value"
        @input="updateValue" />
      <textarea
        v-if="field.type === 'text'"
        v-model="value"
        rows="3"
        @input="updateValue"></textarea>
      <div
        v-if="showAlert"
        class="checkup-field-input-alert">
        Превышено максимальное кол-во символов.
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'CheckupField',

    props: ['field'],

    data() {
      return {
        value: '',
        showAlert: false,
      };
    },

    computed: {},

    methods: {
      toggleField() {
        const data = {
          field: this.field.id,
          value: this.field.type === 'check' ? true : this.value,
        };

        this.$emit('toggle-field', data);
      },

      updateValue() {
        this.showAlert = false;

        if (this.value.length > 250) {
          this.value = this.value.substr(0, 250);
          this.showAlert = true;

          return;
        }

        const data = { field: this.field.id, value: this.value };

        this.$emit('update-value', data);
      },
    },
  }
</script>

<style lang="scss">
  @import "../../assets/scss/variables.scss";

  .checkup-field {
    position: relative;
    padding: 15px 0 15px 40px;
    border-top: 1px solid $light-gray;

    .checkup-field-checkbox {
      position: absolute;
      top: 0;
      left: 0;
      width: 50px;
      padding: 17px 0;

      .checkup-field-dot-circle,
      .checkup-field-circle {
        width: 16px;
        height: 16px;
        margin: 0 auto;
        border: 1px solid $primary;
        border-radius: 8px;
      }

      .checkup-field-dot-circle {
        border-width: 6px;
      }
    }

    i {
      position: absolute;
      top: 17px;
      left: 15px;
      font-size: 16px;
      color: $primary;
    }

    .checkup-field-input {
      margin: 0 20px 0 0;

      input, textarea {
        width: 100%;
        margin: 5px 0;
        padding: 5px 10px;
      }

      .checkup-field-input-alert {
        font-size: 11px;
        color: $text-error;
      }
    }

    &:first-of-type {
      border-top: 0;
    }
  }
</style>
